import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { CrashReportOccurrenceApi } from "../../../../../../../../../../../../../services/Api/Admin/adminTypes";

interface Props {
	occurrence: CrashReportOccurrenceApi;
}

const CrashReportOccurrenceBasicInfoCard = ({ occurrence }: Props) => {
	const { t } = useTranslation("admin");

	const drawDeviceInformation = () => {
		return (
			Object.keys(occurrence.data).length > 0 &&
			Object.entries(occurrence.data).map(([key, value]) => (
				<span key={key}>
					{key}: {value}
				</span>
			))
		);
	};

	const drawOrganizationName = (item: CrashReportOccurrenceApi) => {
		const id = item.organization_name?.substring(
			item.organization_name.indexOf("(") + 1,
			item.organization_name.indexOf(")")
		);
		const name = id ? item.organization_name.split(`(${id}`)[0] : item.organization_name;
		return (
			<div>
				{name}
				{id && <span className="me-2">{id.split("=").join(" ")}</span>}
			</div>
		);
	};

	const drawMessage = () => {
		if (occurrence.message) {
			return occurrence.message.split(`\n`).map((x, index) => <dd key={index}>{x}</dd>);
		}
		return "";
	};

	return (
		<Card className="mb-3 overflow-auto">
			<Card.Header>{t("common.word.basic_data", { ns: "lib" })}</Card.Header>
			<Card.Body>
				<dl className="mb-0">
					<dt>{t("modules.crash_report.field.app_name.title")}</dt>
					<dd>{occurrence.app_name}</dd>
				</dl>
				<dl className="mb-0">
					<dt>{t("common.word.app_version")}</dt>
					<dd>{occurrence.app_version}</dd>
				</dl>
				{occurrence.terminal && (
					<dl className="mb-0">
						<dt>{t("common.word.terminal")}</dt>
						<dd>{occurrence.terminal}</dd>
					</dl>
				)}
				<dl className="mb-0">
					<dt>{t("modules.crash_report.field.created_at.title")}</dt>
					<dd>{FormatDate(occurrence.created_at)}</dd>
				</dl>
				<dl className="mb-0">
					<dt>{t("lib:common.word.venue")}</dt>
					<dd>{drawOrganizationName(occurrence)}</dd>
				</dl>
				<dl className="mb-0">
					<dt>{t("lib:common.word.type")}</dt>
					<dd>{t(`enums.crash_reports.type.${occurrence.type}`)}</dd>
				</dl>
				<dl className="mb-0 text-nowrap">
					<dt>{t("modules.crash_report.field.message.title")}</dt>
					{drawMessage()}
				</dl>
				{Object.keys(occurrence.data).length > 0 && (
					<dl className="mb-0">
						<dt>{t("modules.crash_report.field.device_information.title")}</dt>
						<dd>
							<div className="d-flex flex-column">{drawDeviceInformation()}</div>
						</dd>
					</dl>
				)}
			</Card.Body>
		</Card>
	);
};

export default CrashReportOccurrenceBasicInfoCard;
